import { InfoIcon } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

import type { MondayBoardColumn } from '../../types/integrations';
import MultiColumnSelect from './MultiColumnSelect';

interface Props {
  value: string[];
  columns: MondayBoardColumn[];
  isLoadingColumns: boolean;
  disabled?: boolean;
  onChange: (value: string[]) => void;
}

const MondaySupportVisibleColumnsSection = ({ value, columns, isLoadingColumns, disabled, onChange }: Props) => (
  <div className="border-t border-border-subtle pt-3">
    <div className="flex items-center gap-1.5 mb-3">
      <span className="text-xs font-semibold uppercase tracking-widest text-text-subtle">
        Columnas visibles en tabla de tickets
      </span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <InfoIcon className="size-3.5 text-text-subtle cursor-default shrink-0" />
          </TooltipTrigger>
          <TooltipContent side="right" className="max-w-72">
            Solo las columnas seleccionadas serán consultadas a Monday y mostradas al usuario. La columna de proyecto se
            usa solo para filtrar y nunca se expone.
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    <div className="sm:max-w-[60%]">
      <MultiColumnSelect
        label="Columnas"
        value={value}
        columns={columns}
        isLoading={isLoadingColumns}
        disabled={disabled}
        onChange={onChange}
      />
    </div>
  </div>
);

export default MondaySupportVisibleColumnsSection;
